import React from 'react';
import { Route, RouteProps, useHistory } from 'react-router-dom';
import { useAuthProvider } from '../../providers/Auth';
import { SessionState } from '../../providers/Auth/utils/types';
import Loading from '../Loading';

export const PrivateRoute: React.FC<RouteProps> = ({ ...props }: RouteProps) => {
  const { sessionState, feedbackMessage } = useAuthProvider();
  const history = useHistory();
  switch (sessionState) {
    case SessionState.pendingRefresh:
    case SessionState.valid:
      return <Route {...props} />;
    case SessionState.invalid:
    case SessionState.illegal:
      {
        const to = feedbackMessage === 'signed out' ? undefined : history.location.pathname;
        history.replace('/sign-in', { to });
      }
      return null;
    case SessionState.pendingRehydrate:
    default:
      return <Loading />;
  }
};

export default PrivateRoute;
